var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hs-gradient-button",style:({width: _vm.width, height: _vm.height, fontSize: _vm.fontSize})},[_vm._t("default",function(){return [_c('div',{class:_vm.type,domProps:{"innerHTML":_vm._s(_vm.currentTitle)},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click')}}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }